module.exports = __webpack_public_path__ + "img/4064010900.cd713e13.jpg";